var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnDeleteTrash = function SvgIcnDeleteTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.98468 1.23047C6.51736 1.23047 6.13852 1.60931 6.13852 2.07662V2.35867H10.6513V2.07662C10.6513 1.6093 10.2725 1.23047 9.80519 1.23047H6.98468ZM2.75391 4.33304C2.75391 3.86572 3.13274 3.48688 3.60006 3.48688H3.88228H12.9079H13.1898C13.6571 3.48688 14.036 3.86572 14.036 4.33304V4.89714C14.036 5.36446 13.6571 5.74329 13.1898 5.74329H12.9079V12.5125C12.9079 13.7587 11.8977 14.7689 10.6515 14.7689H6.13869C4.89251 14.7689 3.88228 13.7587 3.88228 12.5125V5.74329H3.60006C3.13274 5.74329 2.75391 5.36446 2.75391 4.89714V4.33304ZM11.7801 5.74329H5.01083V12.5125C5.01083 13.1356 5.51594 13.6407 6.13903 13.6407H10.6519C11.2749 13.6407 11.7801 13.1356 11.7801 12.5125V5.74329Z",
    fill: "currentcolor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnDeleteTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_delete_trash.d39f4c6d.svg";
export { ForwardRef as ReactComponent };